export abstract class UuidPort {
  abstract generate(): string;
}
